export default __webpack_public_path__ + "static/media/bg-pattern-footer.8d9d044c.svg";